<div class="login-container">
  <div class="card-container">
    <div class="title">Mot de passe oublié ?</div>
    <div class="subtitle fs-14">
      Vous allez recevoir des instructions par e-mail pour réinitialiser votre
      mot de passe.
    </div>
    <div class="mt-3">
      <app-custom-input
        label="Email"
        [parentForm]="formGroup"
        controlName="email"
      ></app-custom-input>
      <div class="text-secondary">
        Adresse e-mail avec laquelle vous avez créé votre compte Collary.
      </div>
    </div>
    <app-button
      text="Envoyer"
      innerClass="mt-3 w-100"
      (handleClick)="forgotPassword()"
    ></app-button>
    <div class="text-action cursor-pointer fs-16 mt-3" routerLink="/login">
      Retour à la page connexion
    </div>
  </div>
</div>

<!-- <div class="login-container">
  <div class="card-container">
    <svg-icon src="assets/icons/check-circle.svg"></svg-icon>
    <div class="title mt-3">Lien de réinitialisation envoyé</div>
    <div class="subtitle">
      Un lien pour réinitialiser votre mot de passe vous a été envoyé à
      l'adresse {{ "sophie.martin@novacare.com" }}
    </div>
    <div class="text-action mt-3">Retour à la page connexion</div>
  </div>
</div> -->
